













































import { Component, Prop } from 'vue-property-decorator';
import {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPopup,
    DxForm,
    DxLookup
} from 'devextreme-vue/data-grid';
import { DxItem } from 'devextreme-vue/form';
import { DataSource } from '@/types';
import {
    Table,
    TableConfig,
    defaultTableConfig,
    removeItemsFromView,
    columnTemplates
} from '@/core/components/table';
import {
    CONTRACTS,
    WindowsServiceContract,
    FetchServiceContract
} from '@/core/contracts';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { DayInactivityInterval, ActivitySchedule } from '@/dto';
import { ContextsState } from '@/store';
import { localize } from '@/core/filters';
import DevExpress from 'devextreme/bundles/dx.all';
import { DxRequiredRule, DxCustomRule } from 'devextreme-vue/validator';
import Validators from '@/core/helpers/validators';

@Component({
    components: {
        DxDataGrid,
        DxColumn,
        DxEditing,
        DxPopup,
        DxForm,
        DxItem,
        DxRequiredRule,
        DxCustomRule,
        DxLookup
    }
})
export default class DayInactivityIntervalsListTable extends Validators {
    @Prop({ type: String, required: true }) public tableKey!: string;
    @Prop({ type: Object, required: true }) public dataSource!: DataSource;
    @Prop({ type: Array, required: false }) public activitySchedules!: ActivitySchedule[];
    @Prop({ type: String, required: false, default: null }) public selectedAlias!: string | null;

    @Inject(CONTRACTS.WindowsService)
    private _windowsService?: WindowsServiceContract;
    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;

    public get tableConfig(): Partial<TableConfig> {
        return {
            ...defaultTableConfig(this)
        };
    }

    public async mounted() {
        // raise instance of the table up to parent
        this.$emit('setTableInstance', this.tableInstance);
    }

    public get tableInstance(): Table {
        const element = this.$refs['data-grid'] as unknown;
        return (element as DxDataGrid).instance!;
    }

    public get columnTemplates() {
        return columnTemplates;
    }

    public get localize() {
        return localize;
    }

    public getDataGridInstance(): Table {
        const element = this.$refs['data-grid'] as unknown;
        return (element as DxDataGrid).instance!;
    }

    public initNewRow(row: any) {
        row.data.startTimeOffset = row.data.startTimeOffset !== null
                                        && row.data.startTimeOffset !== undefined
                                        ? row.data.startTimeOffset : '00:00:00';
        row.data.finishTimeOffset = row.data.finishTimeOffset !== null
                                        && row.data.finishTimeOffset !== undefined
                                        ? row.data.finishTimeOffset : '00:00:00';
    }

    public deleteDayInactivityInterval() {
        this._windowsService!.showDialog(
            localize('DayInactivityIntervalSimpleDeleteMessage'),
            [
                { id: 1, caption: localize('DialogYes') },
                { id: 2, caption: localize('DialogCancel') }
            ]
        ).then(id => {
            if (id === 1) {
                const dayIncativityInterval = this.tableInstance.getSelectedRowsData()[0];
                const data = {
                    DayInactivityIntervals_Partial: [
                        {
                            id: dayIncativityInterval.id,
                            IsDeleted: true
                        }
                    ]
                };
                const currentContextId = ContextsState.currentContextId;
                const url = `/files/contexts/${currentContextId}?ignoreWarnings=true`;
                this._fetchService!.post<DayInactivityInterval>(
                    url,
                    JSON.stringify(data)
                ).then(() => this.getDataGridInstance().refresh());
            }
        });
    }
}
